var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.16667H9.16667C9.625 4.16667 10 3.79167 10 3.33333C10 2.875 9.625 2.5 9.16667 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H9.16667C9.625 17.5 10 17.125 10 16.6667C10 16.2083 9.625 15.8333 9.16667 15.8333H4.16667V4.16667Z",
    fill: "#DA1414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 9.70834L14.8833 7.38334C14.8254 7.3238 14.751 7.2829 14.6696 7.26589C14.5883 7.24888 14.5037 7.25653 14.4268 7.28785C14.3498 7.31917 14.284 7.37274 14.2376 7.44171C14.1913 7.51068 14.1666 7.59191 14.1667 7.675V9.16667H8.33333C7.875 9.16667 7.5 9.54167 7.5 10C7.5 10.4583 7.875 10.8333 8.33333 10.8333H14.1667V12.325C14.1667 12.7 14.6167 12.8833 14.875 12.6167L17.2 10.2917C17.3667 10.1333 17.3667 9.86667 17.2083 9.70834Z",
    fill: "#DA1414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.e5443faa08cead634e4cc6f1137dd2a0.svg";
export { ForwardRef as ReactComponent };